// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MTtA","footer":"styles_footer__z9l3j","passCodeTooltip":"styles_passCodeTooltip__15GOv"};